import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { OrderDirection } from '../../Datatable/OrderDirection';
import CompanyNamePICQueryModel from '../models/CompanyNamePICQueryModel';
import CompanyNamePICModel from '../models/CompanyNamePICModel';
import { QueryItem } from '../../Tonnage/models/TonnageQueryModel';

interface CompanyNamePICSearchState {
    query: CompanyNamePICQueryModel,
    searchResults: CompanyNamePICModel[],
    companyNamePICSearchKeyword: string,
    triggerSearch: number,
    selectedCompanyNamePICs: CompanyNamePICModel[],
    datatableSelectedIndex: number,
    searchResultTotalRecord: number,
    triggerFocusCompanyName: number
    checkedCompanyNamePICs: CompanyNamePICModel[],
}

const initialState: CompanyNamePICSearchState = {
    query: {
        companyNames: [],
        pics: [],
        emails: [],
        orderBy: "updatedDate",
        orderDirection: OrderDirection.Desc,
    } as CompanyNamePICQueryModel,
    searchResults: [],
    companyNamePICSearchKeyword: "",
    selectedCompanyNamePICs: [],
    triggerSearch: 0,
    datatableSelectedIndex: -1,
    searchResultTotalRecord: 0,
    triggerFocusCompanyName: 0,
    checkedCompanyNamePICs: []
}

export const CompanyNamePICSearchSlice = createSlice({
    name: "CompanyNamePICSearch",
    initialState,
    reducers: {
        setCompanyNames: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.companyNames = action.payload;
        },
        setPics: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.pics = action.payload;
        },
        setEmails: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.emails = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.query.orderBy = action.payload;
        },
        setOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.query.orderDirection = action.payload;
        },
        setCompanyNamePICs: (state, action: PayloadAction<CompanyNamePICModel[]>) => {
            state.searchResults = action.payload;
        },
        setTriggerCompanyNamePICSearch: (state, action: PayloadAction<number>) => {
            state.triggerSearch = action.payload;
        },
        setCompanyNamePICSearchKeyword: (state, action: PayloadAction<string>) => {
            state.companyNamePICSearchKeyword = action.payload;
        },
        setDatatableSelectedCompanyNamePICIndex: (state, action: PayloadAction<number>) => {
            state.datatableSelectedIndex = action.payload;
        },
        setSearchResultTotalRecord: (state, action: PayloadAction<number>) => {
            state.searchResultTotalRecord = action.payload;
        },
        setCompanyNamePICquery: (state, action: PayloadAction<CompanyNamePICQueryModel>) => {
            state.query = action.payload;
        },
        resetCompanyNamePICSearch: (state) => {
            state.query = initialState.query;
        },
        setSelectedCompanyNamePICs: (state, action: PayloadAction<CompanyNamePICModel[]>) => {
            state.selectedCompanyNamePICs = action.payload;
        },
        setTriggerFocusCompanyName: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyName = action.payload;
        },
        setCheckedCompanyNamePICs: (state, action: PayloadAction<CompanyNamePICModel[]>) => {
            state.checkedCompanyNamePICs = action.payload;
        },
    }
});

export const CompanyNamePICSearchSelector = createSelector(
    (state: RootState) => state.companyNamePICSearch,
    (data) => data
);

export const {
    setCompanyNames,
    setPics,
    setEmails,
    setOrderBy,
    setCompanyNamePICSearchKeyword,
    setOrderDirection,
    setCompanyNamePICs,
    setTriggerCompanyNamePICSearch,
    setDatatableSelectedCompanyNamePICIndex,
    setSearchResultTotalRecord,
    setCompanyNamePICquery,
    resetCompanyNamePICSearch,
    setSelectedCompanyNamePICs,
    setTriggerFocusCompanyName,
    setCheckedCompanyNamePICs
} = CompanyNamePICSearchSlice.actions;

export default CompanyNamePICSearchSlice.reducer;